import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { take, map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent {
  isCollapsed = true;
  isAdmin = false;
  show = false;

  constructor(
    public auth: AuthService) {
      this.auth.user.pipe(
        take(1),
        map(user => {
          if (user) {
            this.isAdmin = user.email.split('@')[0] === 'mverges';
          }
          return !!user;
        }),
        tap(loggedIn => {
        })
      );
    }

  toggleCollapse() {
    this.show = !this.show;
  }

}
